import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { CalendarFilledSvg } from 'components/icons';
import { textEllipsis } from 'utils/ellipsis';
import { Empty, SecondaryTextSm } from 'atoms';
import { Mr1 } from 'wrappers';

const recurringDays = (order) => {
  let weekdays = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  let wDays = order?.schedule?.wday;
  let day = order?.schedule?.day;
  let month = order?.schedule?.month;

  let newYearArray = month?.map((item, i) =>
    `${item}/${day[i]}`
  )

  let resultent = wDays?.map((item, i) => {
    return weekdays[item];
  });

  return wDays ? `Weekly on ${resultent} ` ?? '' : month ? `Yearly on ${newYearArray} ` ?? '' : `Monthly on ${day} ` ?? '';
}

const template = styled.div`
  
  display: flex;
  align-items: center;

  position: relative;
  cursor: pointer;

  span {
    display: none;
  }

  &:hover {
    span {
      display: unset;
    }
  }
`;

export default Molecule({
  template,
  atoms: [
    {
      component: wrap(Empty, Mr1),
      name: 'Icon',
      displayValue: ({ }) => CalendarFilledSvg({}),
    },
    {
      component: SecondaryTextSm,
      name: 'Reccurs',
      displayValue: ({ order }) => textEllipsis(recurringDays(order), 25) || '',
    },
  ],
});
